import { Injectable } from '@angular/core';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';

@Injectable()
export class TinymceService {
    public static MAX_FILE_SIZE = 10 * 1024 * 1024;

    emojiPosition = {
        强壮: '-5px -5px',
        亲亲: '-107px -5px',
        调皮: '-107px -39px',
        皱眉: '-73px -107px',
        呲牙: '-141px -39px',
        大哭: '-141px -73px',
        惊讶: '-5px -141px',
        '1f31d': '-39px -5px',
        OK: '-5px -39px',
        '1f60a': '-39px -39px',
        '1f60b': '-73px -5px',
        '1f60c': '-73px -39px',
        '1f92e': '-39px -175px',
        '1f389': '-73px -175px',
        '1f576': '-107px -175px',
        '1f600': '-141px -175px',
        大笑: '-175px -175px',
        破涕为笑: '-209px -5px',
        '1f603': '-209px -39px',
        '1f604': '-209px -73px',
        '1f605': '-209px -107px',
        '1f606': '-209px -141p',
        '1f607': '-209px -175px',
        '1f608': '-5px -209px',
        '1f609': '-39px -209px',
        '1f610': '-73px -209px',
        '1f611': '-107px -209px',
        '1f612': '-141px -209px',
        '1f613': '-175px -209px',
        失望: '-209px -209px',
        撇嘴: '-243px -5px',
        '1f616': '-243px -39px',
        '1f617': '-243px -73px',
        '1f619': '-243px -107px',
        '1f618': '-243px -141px',
        '1f620': '-243px -175px',
        愤怒: '-243px -209px',
        '1f622': '-5px -243px',
        '1f623': '-39px -243px',
        汗: '-107px -243px',
        '1f626': '-141px -243px',
        '1f627': '-175px -243px',
        '1f628': '-209px -243px',
        疲倦: '-243px -243px',
        '1f630': '-277px -5px',
        惊恐: '-277px -39px',
        惊慌: '-277px -73px',
        '1f633': '-277px -107px',
        睡着了: '-277px -141px',
        '1f635': '-277px -175px',
        '1f636': '-277px -209px',
        生病: '-277px -243px',
        猫脸笑: '-5px -277px',
        '1f639': '-39px -277px',
        '1f640': '-73px -277px',
        不开心: '-107px -277px',
        '1f642': '-141px -277px',
        '1f643': '-175px -277px',
        闭嘴: '-209px -277px',
        笑: '-243px -277px',
        困: '-277px -277px',
        饥饿: '-311px -5px',
        闪电: '-311px -39px',
        温馨: '-311px -73px',
        难过: '-311px -107px',
        泪汪汪: '-344px -208px',
        刀: '-344px 0px',
        西瓜: '-344px -140px',
        碰杯: '-344px -106px',
        篮球: '-311px -140px',
        乒乓球: '-311px -175px',
        咖啡: '-311px -242px',
        玫瑰: '-344px -38px',
        凋谢: '-311px -208px',
        心动: '-344px -72px',
        心碎: '-311px -276px',
        太阳: '-344px -244px',
        蛋糕: '-344px -174px',
    };

    constructor() {}

    static formatBytes(bytes, decimals?): string {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024,
            dm = decimals || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    /**
     * @desc 验证文件大小，格式是否正确
     */
    isValidFile(file, showError = true): boolean {
        const reg = new RegExp(/\.(jpe?g|png)$/i);
        const formatMatch = reg.test(file.name);
        const maxSize = TinymceService.MAX_FILE_SIZE;
        if (!formatMatch || file.size > maxSize) {
            if (showError) {
                let message = '',
                    title = '';
                if (!formatMatch) {
                    title = `文件${file.name}格式不正确`;
                    message = '可用图片格式：jpg，jpeg，png。';
                } else {
                    title = `图片${file.name}超过限制大小`;
                    message = `图片${file.name}，大小${TinymceService.formatBytes(file.size)},
        超过所允许的最大尺寸${TinymceService.formatBytes(maxSize)}`;
                }
                // appAlert.common.confirmWarning(title, message);
            }
            return false;
        }
        return true;
    }
    /**
     * @desc 验证视频文件大小，格式是否正确
     */
    isValidVideo(file, showError = true): boolean {
        const reg = new RegExp(/\.(mp4|avi|mov|rmvb|flv)$/i);
        const formatMatch = reg.test(file.name);
        const maxSize = 100 * 1024 * 1024;
        if (formatMatch && file.size <= maxSize) {
            return true;
        }
        if (!showError) {
            return false;
        }
        let message = '',
            title = '';
        if (!formatMatch) {
            title = `文件${file.name}格式不正确`;
            message = '可用视频格式：mp4、AVI、mov、rmvb、rm、FLV';
        } else {
            title = `视频${file.name}超过限制大小`;
            message = `视频${file.name}，大小${TinymceService.formatBytes(file.size)},
    超过所允许的最大尺寸${TinymceService.formatBytes(maxSize)}`;
        }
        // appAlert.common.confirmWarning(title, message);
    }

    /***
     * 将图片的文件流转换成url
     *
     */
    imgFileStreamToUrl(item): Promise<any> {
        return new Promise((reslove) => {
            if (item) {
                const { _file } = item;
                const reader = new FileReader();
                reader.readAsDataURL(_file);
                reader.onload = (evt) => {
                    if (evt && evt.target) {
                        const fileUrl = (evt.target as any).result;
                        reslove(fileUrl);
                    }
                };
            }
        });
    }
}
